import { yupResolver } from '@hookform/resolvers/yup'
import { Check } from '@mui/icons-material'
import {
  editUserFormDefaultValues,
  editUserFormSchema,
} from 'feature/user/helpers/editFitterFormObjects'
import {
  useGetFitterQuery,
  useUpdateFitterMutation,
} from 'feature/user/redux/fitter.api'
import {
  TFitterProfileUpdateFormMethod,
  TFitterProfileUpdateRequest,
} from 'feature/user/types'

import { useEffect, useState } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { useNavigate } from 'react-router'
import { LoaderInCentalPosition } from 'widget'
import { EditFitterDataForm } from 'widget/EditFitterDataForm/EditFitterDataForm'

// страница настроек пользователя
export function FitterEditProfile() {
  const [isSubmitting, setIsSubmitting] = useState(false)
  const navigate = useNavigate()
  const { data, isLoading, isFetching } = useGetFitterQuery()
  const [updateFitter] = useUpdateFitterMutation()

  const formMethods = useForm<TFitterProfileUpdateFormMethod>({
    // @ts-ignore
    resolver: yupResolver(editUserFormSchema),
    mode: 'onChange',
  })

  const { reset, getValues, trigger } = formMethods

  useEffect(() => {
    if (data) {
      reset(editUserFormDefaultValues(data))
      trigger()
    }
  }, [data, reset])

  const onSubmit = async () => {
    setIsSubmitting(true)

    const currentValues = getValues()
    const serviceRegions = currentValues.serviceRegions.map(region => ({
      kladrId: region.kladrId,
      regionKladrId: null,
      cityKladrId: null,
      areaKladrId: null,
    }))

    const formData: TFitterProfileUpdateRequest = {
      firstName: currentValues.firstname,
      lastName: currentValues.lastname,
      fatherName: currentValues.middlename,
      locationAddress: currentValues.locationAddress,
      email: currentValues.email,
      companyName: currentValues.companyName,
      productTypes: currentValues.productTypes,
      serviceRegions: serviceRegions,
    }
    try {
      await updateFitter(formData)
    } finally {
      setIsSubmitting(false)
      navigate('/settings')
    }
  }

  if (isLoading || isFetching) return <LoaderInCentalPosition />

  return (
    <FormProvider {...formMethods}>
      <div className='container'>
        <EditFitterDataForm
          sendButton={{
            startIcon: <Check />,
            isLoading: isSubmitting,
          }}
          onSubmit={onSubmit}
        />
      </div>
    </FormProvider>
  )
}
